export const iconFontAwesomeUsersPeoplePersonDigging = (
	<i className="fa-solid fa-person-digging"></i>
);
